/**
 * End node — small pill: neutral for `completed`, rose for `errored`,
 * amber for `cancelled` (Section 5).
 */

import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { EndRfNode } from '../layout.js';

export function EndNode({ data }: NodeProps<EndRfNode>) {
  const palette =
    data.outcome === 'errored'
      ? 'bg-rose-50 text-rose-700 ring-rose-200'
      : data.outcome === 'cancelled'
        ? 'bg-amber-50 text-amber-700 ring-amber-200'
        : 'bg-slate-100 text-slate-700 ring-slate-300';

  return (
    <div
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wider shadow-sm ring-1 ${palette}`}
      style={{ minWidth: 120 }}
    >
      <span aria-hidden="true">●</span>
      <span className="truncate">{data.label}</span>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={false}
        style={{ background: '#94A7BE', width: 8, height: 8, border: '2px solid white' }}
      />
    </div>
  );
}
